<a
  [href]="url"
  target="_blank"
  [style.color]="color"
  [style.text-decoration]="textDecoration ? 'underline' : 'none'"
  matTooltip="View in new tab">
  {{ name }}
</a>
